import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Divider,
  Grid,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { useFormContext } from './FormContext';

const Page5Limits: React.FC = () => {
  const { 
    formData, 
    errors, 
    handleChange, 
    handleMultiSelectChange 
  } = useFormContext();

  return (
    <>
      <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 2, color: "primary.main" }}>
        Seção 5: Limites e Escalonamento (Quando Pedir Ajuda)
      </Typography>
      <Typography variant="body2" gutterBottom sx={{ mb: 2, fontStyle: 'italic' }}>
        É crucial definir quando o assistente deve parar e chamar um humano.
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            id="forbiddenTopics"
            label="Existem assuntos sobre os quais o assistente NUNCA deve falar ou dar opinião?"
            name="forbiddenTopics"
            multiline
            rows={3}
            value={formData.forbiddenTopics}
            onChange={handleChange}
            helperText="Ex: política, concorrentes, informações financeiras confidenciais"
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom>
            Quando o assistente deve transferir o atendimento para você? (Situações que exigem intervenção humana)
          </Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.transferConditions.includes('request_human')}
                  onChange={handleMultiSelectChange('transferConditions')}
                  value="request_human"
                />
              }
              label='Quando o cliente pedir para "falar com um atendente/humano".'
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.transferConditions.includes('upset_customer')}
                  onChange={handleMultiSelectChange('transferConditions')}
                  value="upset_customer"
                />
              }
              label="Se o cliente parecer irritado ou insatisfeito."
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.transferConditions.includes('price_negotiation')}
                  onChange={handleMultiSelectChange('transferConditions')}
                  value="price_negotiation"
                />
              }
              label="Para negociar preços ou descontos."
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.transferConditions.includes('complex_sale')}
                  onChange={handleMultiSelectChange('transferConditions')}
                  value="complex_sale"
                />
              }
              label="Para fechar uma venda complexa."
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.transferConditions.includes('specific_question')}
                  onChange={handleMultiSelectChange('transferConditions')}
                  value="specific_question"
                />
              }
              label="Se a pergunta for muito específica e não estiver na base de conhecimento."
            />
          </FormGroup>
          {errors.transferConditions && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {errors.transferConditions}
            </Typography>
          )}
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            id="transferMessage"
            label="Qual é a mensagem que o assistente deve usar para transferir o atendimento?"
            name="transferMessage"
            multiline
            rows={3}
            value={formData.transferMessage}
            onChange={handleChange}
            error={!!errors.transferMessage}
            helperText={errors.transferMessage || 'Exemplo: "Entendi! Para te ajudar com essa questão específica, vou chamar um de nossos especialistas. Por favor, aguarde um momento que um humano já irá te atender."'}
            required
          />
        </Grid>
      </Grid>
    </>
  );
};

export default Page5Limits;